import {
    FETCH_PAYMENTS_REPORT,
} from '../../actions/types';

const INITIAL_STATE = {
    paymentsReport: [],    
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_PAYMENTS_REPORT:
            return { ...state, paymentsReport: action.payload };
        default:
            return state;
    }
};
